<template>
  <div>
    <base-modal :isOpen="isOpen" :title="$t('files') | capitalize" @close="$emit('close')" size="lg">
      <!-- Body -->
      <template #body>
        <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px" style="border:none;"></iframe>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
export default {
  name: 'PdfViewer',
  components: { BaseModal},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      required: true
    },
  }
}

</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
  max-height: 50px;
  overflow-y: auto;
}
</style>
